import store from 'Store/index';

export function potentialTabAllowed() {
	const hasCustomerPortfolioPotential = Tools.FeatureHelper.isAvailable(
		Tools.FeatureHelper.Feature.CUSTOMER_PORTFOLIO_POTENTIAL
	);
	const hasFullReportAccess = store.getState().App.hasFullReportAccess ?? false;

	return hasCustomerPortfolioPotential && hasFullReportAccess;
}

export default function allowed() {
	return true;
}
